import { selectFeatureFlags } from 'core/userContext';
import { FC, useState } from 'react';
import { useSelector } from 'react-redux';
import { ALL_TIME } from 'ui/datePicker/helpers';
import {
  serializationOptionsForStringValue,
  useSearchParamState,
} from 'utils/hooks/useSearchParamState';
import { SEARCH_QUERY_PARAM } from '../constants';
import { INGESTION_POLICIES } from '../types';
import { FiltersContext } from './FiltersContext';

export const FiltersContextProvider: FC<React.PropsWithChildren<unknown>> = ({ children }) => {
  const { CustomEventsPageModernized } = useSelector(selectFeatureFlags);

  const [ingestionPolicyFilter, setIngestionPolicyFilter] = useState(
    CustomEventsPageModernized ? INGESTION_POLICIES.SAVED : INGESTION_POLICIES.ALL,
  );

  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [preset, setPreset] = useState(ALL_TIME);

  const [searchQuery, setSearchQuery] = useSearchParamState({
    searchParamKey: SEARCH_QUERY_PARAM,
    stateValueWhenSearchParamIsUnset: '',
    pushChangesToBrowserHistory: true,
    ...serializationOptionsForStringValue,
  });

  return (
    <FiltersContext.Provider
      value={{
        ingestionPolicyFilter,
        setIngestionPolicyFilter,
        searchQuery,
        setSearchQuery,
        startDate,
        setStartDate,
        endDate,
        setEndDate,
        preset,
        setPreset,
      }}
    >
      {children}
    </FiltersContext.Provider>
  );
};
